/**
 * 入驻申请状态。**单点定义在这里,三端引用**(CLAUDE.md 硬约束「枚举单点定义」)。
 *
 * prisma/schema.prisma 里有一份同名的数据库枚举,那是不得不有的第二处 ——
 * 数据库需要自己的类型定义。两处的一致性不靠人记得:
 * apps/api/src/common/enum-parity.ts 里有一条类型级断言,两边一旦对不上,
 * `pnpm typecheck` 直接失败(typecheck 守卫会红)。
 * 这比再写一条守卫便宜,而且不可能被绕过。
 */
export const CARRIER_APPLICATION_STATUS = ['pending', 'approved', 'rejected'] as const

export type CarrierApplicationStatus = (typeof CARRIER_APPLICATION_STATUS)[number]

export function isCarrierApplicationStatus(x: unknown): x is CarrierApplicationStatus {
  return typeof x === 'string' && (CARRIER_APPLICATION_STATUS as readonly string[]).includes(x)
}
